import React, { useState } from 'react';

// EditableText is the click-to-edit field detail pages use for a record's
// name and WhatsApp aliases (project and list detail pages; styles from
// WeightLots.css: wld-name / wld-matches). onSave gets the trimmed text, and
// is only called when it changed.
const EditableText = ({ value, className, inputClassName, label, placeholder, onSave }) => {
  const [editing, setEditing] = useState(false);
  const [draft,   setDraft]   = useState(value || '');

  const save = () => {
    setEditing(false);
    if (draft.trim() !== (value || '')) onSave(draft.trim());
  };

  if (editing) {
    return (
      <input className={inputClassName} value={draft}
        onChange={e => setDraft(e.target.value)}
        onBlur={save} onKeyDown={e => e.key === 'Enter' && save()}
        placeholder={placeholder} autoFocus />
    );
  }
  return (
    <div className={className} onClick={() => { setDraft(value || ''); setEditing(true); }}>
      {label && <span className="wld-matches-label">{label}: </span>}
      {value || <span className="wld-empty">{placeholder}</span>}
      <span className="wld-edit-hint"> ✎</span>
    </div>
  );
};

export default EditableText;
